'use strict';

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

require('../../styles/components/single-toggle.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*-------------------------------
Single Toggle
-------------------------------*/

document.addEventListener('DOMContentLoaded', function (event) {
  // Get the clickable toggle headers.
  var singleToggleHeaders = document.querySelectorAll('.single-toggle__header');

  // Once a toggle header is clicked then apply the open class to the container.
  // Animations within the container are triggered using css.
  [].concat((0, _toConsumableArray3.default)(singleToggleHeaders)).forEach(function (toggleHeader) {
    toggleHeader.addEventListener('click', function () {
      var toggleContainer = this.closest('.single-toggle');
      toggleContainer.classList.toggle('open');
    });
  });
}); /*-------------------------------
    Style
    -------------------------------*/